import { IconType } from "react-icons";
import { GiPayMoney, GiPlatform } from "react-icons/gi";
import { BiHelpCircle } from "react-icons/bi";

import { RiLuggageCartFill, RiWirelessChargingLine } from "react-icons/ri";
import { FiUsers } from "react-icons/fi";
import {
  IoStorefrontOutline,
  IoLibraryOutline,
  IoPeopleCircleOutline,
} from "react-icons/io5";

import { CgProfile, CgUserList } from "react-icons/cg";
import { MdOutlineDevices, MdPlaylistAdd, MdOutlineSchool, MdOutlineApi, MdOutlineWeb } from "react-icons/md";
import { FiZap } from "react-icons/fi";
import { FaBoxes } from "react-icons/fa";
import { AiOutlineUsergroupAdd } from "react-icons/ai";

interface MenuItemInterface {
  name: string;
  i18Key: string;
  isAdmin: boolean;
  path: string;
  showToAdmin: boolean;
  subsCanAccess: string[];
  Icon: IconType;
  disabled?: boolean;
  stagingTag?: "live" | "disabled" | "admin-only";
}

export const MenuItems: MenuItemInterface[] = [
  {
    name: "academy",
    i18Key: "menuItemAcademy",
    isAdmin: false,
    path: "/app/academy",
    showToAdmin: true,
    subsCanAccess: ["Oro", "Plata", "Bronce", "Creyentes", "Basic", "Trial", "Free"],
    Icon: MdOutlineSchool,
    disabled: false,
    stagingTag: "live",
  },
  {
    name: "Products",
    i18Key: "menuItemProducts",
    isAdmin: false,
    path: "/app/products",
    showToAdmin: true,
    subsCanAccess: [
      "Oro",
      "Plata",
      "Bronce",
      "Creyentes",
      "Basic",
      "Trial",
      "Free",
    ],
    Icon: RiLuggageCartFill,
    stagingTag: "live",
  },
  {
    name: "landings_ai",
    i18Key: "menuItemLandingsAi",
    isAdmin: true,
    path: "/app/landings-ai",
    showToAdmin: true,
    subsCanAccess: ["Oro", "Plata", "Bronce", "Creyentes", "Basic", "Trial", "Free"],
    Icon: FiZap,
    stagingTag: "admin-only",
  },
  {
    name: "landing_creator",
    i18Key: "menuItemLandingCreator",
    isAdmin: false,
    path: "/app/landing-creator",
    showToAdmin: true,
    subsCanAccess: ["Oro", "Plata", "Bronce", "Creyentes", "Basic", "Trial", "Free"],
    Icon: MdOutlineWeb,
    disabled: true,
    stagingTag: "disabled",
  },
  {
    name: "viraly_ai",
    i18Key: "menuItemViralyAi",
    isAdmin: true,
    path: "/app/viraly_ai",
    showToAdmin: true,
    subsCanAccess: ["none"],
    Icon: RiWirelessChargingLine,
    disabled: true,
    stagingTag: "disabled",
  },
  {
    name: "suggest_product",
    i18Key: "menuItemSuggestProducts",
    isAdmin: false,
    path: "/app/suggest/product",
    showToAdmin: false,
    subsCanAccess: ["Oro", "Plata", "Bronce", "Creyentes", "Basic", "Trial"],
    Icon: MdPlaylistAdd,
    stagingTag: "live",
  },
  {
    name: "suggested_products_list",
    i18Key: "menuItemSuggestedProducts",
    isAdmin: true,
    path: "/app/suggested/products",
    showToAdmin: true,
    subsCanAccess: ["Oro", "Plata", "Bronce", "Creyentes", "Basic", "Trial"],
    Icon: FaBoxes,
    stagingTag: "admin-only",
  },
  {
    name: "Platforms",
    i18Key: "menuItemPlatforms",
    isAdmin: false,
    path: "/app/platforms",
    showToAdmin: true,
    subsCanAccess: ["none"],
    Icon: GiPlatform,
    stagingTag: "admin-only",
  },
  {
    name: "apis",
    i18Key: "menuItemApis",
    isAdmin: true,
    path: "/app/apis",
    showToAdmin: true,
    subsCanAccess: ["none"],
    Icon: MdOutlineApi,
    disabled: true,
    stagingTag: "disabled",
  },
  {
    name: "my_list",
    i18Key: "menuItemMyProducts",
    isAdmin: false,
    path: "/app/my_lists",
    showToAdmin: true,
    subsCanAccess: ["Oro", "Plata", "Bronce", "Creyentes", "Basic", "Trial"],
    Icon: CgUserList,
    stagingTag: "live",
  },
  {
    name: "store",
    i18Key: "menuItemStores",
    isAdmin: false,
    path: "/app/stores",
    showToAdmin: false,
    subsCanAccess: ["Oro", "Plata", "Bronce", "Creyentes", "Basic", "Trial"],
    Icon: IoStorefrontOutline,
    stagingTag: "live",
  },
  {
    name: "fads",
    i18Key: "menuItemAds",
    isAdmin: false,
    path: "/app/library_ads",
    showToAdmin: true,
    subsCanAccess: ["Oro", "Plata", "Bronce", "Creyentes", "Basic", "Trial"],
    Icon: IoLibraryOutline,
    disabled: true,
    stagingTag: "disabled",
  },
  // {
  //   name: "community",
  //   i18Key: "community",
  //   isAdmin: false,
  //   path: "",
  //   showToAdmin: true,
  //   subsCanAccess: ["Oro", "Plata", "Bronce", "Creyentes", "Basic", "Trial"],
  //   Icon: IoPeopleCircleOutline,
  // },
  {
    name: "profile",
    i18Key: "menuItemProfile",
    isAdmin: false,
    path: "/app/profile",
    showToAdmin: true,
    subsCanAccess: [
      "Oro",
      "Plata",
      "Bronce",
      "Creyentes",
      "Basic",
      "Trial",
      "Free",
    ],
    Icon: CgProfile,
    stagingTag: "live",
  },
  {
    name: "referrals",
    i18Key: "menuItemReferrals",
    isAdmin: false,
    path: "/app/referrals",
    showToAdmin: false,
    subsCanAccess: [
      "Oro",
      "Plata",
      "Bronce",
      "Creyentes",
      "Basic",
      "Trial",
      "Free",
    ],
    Icon: AiOutlineUsergroupAdd,
    stagingTag: "live",
  },
  {
    name: "users",
    i18Key: "menuItemUsers",
    isAdmin: true,
    path: "/app/users",
    showToAdmin: true,
    subsCanAccess: ["none"],
    Icon: FiUsers,
    stagingTag: "admin-only",
  },
  {
    name: "request_devices",
    i18Key: "menuItemDevices",
    isAdmin: true,
    path: "/app/devices",
    showToAdmin: true,
    subsCanAccess: ["none"],
    Icon: MdOutlineDevices,
    stagingTag: "admin-only",
  },
  {
    name: "request_withdrawals",
    i18Key: "menuItemWithdrawals",
    isAdmin: true,
    path: "/app/withdrawals",
    showToAdmin: true,
    subsCanAccess: ["none"],
    Icon: GiPayMoney,
    stagingTag: "admin-only",
  },
  {
    name: "frequent_questions",
    i18Key: "menuItemFrequentQuestions",
    isAdmin: false,
    path: "/app/frequent_questions",
    showToAdmin: true,
    subsCanAccess: [
      "Oro",
      "Plata",
      "Bronce",
      "Creyentes",
      "Basic",
      "Trial",
      "Free",
    ],
    Icon: BiHelpCircle,
    stagingTag: "live",
  },
];
